import { FunctionComponent, PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';

export const TicketDrawerBlock: FunctionComponent<
    PropsWithChildren<{
        header: string;
    }>
> = ({ header, children }) => {
    return (
        <Box
            sx={{
                p: 4,
                borderBottom: '1px solid',
                borderColor: (theme) => theme.palette.divider,
            }}
        >
            <Typography
                sx={{
                    fontWeight: 600,
                    mb: 2,
                }}
            >
                {header}
            </Typography>

            <Box
                sx={{
                    ml: 2,
                }}
            >
                {children}
            </Box>
        </Box>
    );
};
